import React, { useEffect } from 'react';
import { CountdownProvider } from './contexts/CountdownContext';
import { initMetaPixel } from './utils/metaPixel';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { Agitation } from './components/Agitation';
import { OfferStack } from './components/OfferStack';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CountdownProvider data-id="element-0" data-mp="31aysc7e49y1x">
      <div className="w-full bg-bone font-body" data-id="element-1" data-mp="31bianp7oiogh">
        <StickyBar data-id="element-2" data-mp="2wk06ksad07ra" />
        <main data-id="element-3" data-mp="2wjqi594yq8np">
          <Hero data-id="element-4" data-mp="2wiyvwox99na3" />
          <Agitation data-id="element-5" data-mp="2wifh3h2wjf0a" />
          <OfferStack data-id="element-6" data-mp="2wi5n7ieqknpb" />
          <Testimonials data-id="element-7" data-mp="28u5zysgmvffh" />
          <Faq data-id="element-8" data-mp="28te21azkd5m1" />
          <FinalCta data-id="element-9" data-mp="28suumo7jhzm9" />
        </main>
        <Footer data-id="element-10" data-mp="28s2z1ddy01vz" />
      </div>
    </CountdownProvider>;
}